module.exports = __webpack_public_path__ + "static/media/logo.13ec18d4.jpg";